import { ILocationWithIds } from "@/types";
import { Box, Button, Typography } from "@mui/material";

export function RouteCell({
  locations,
  type,
  openModal,
}: {
  locations: ILocationWithIds[];
  type: 'pickup' | 'delivery';
  openModal: (type: 'pickup' | 'delivery', data: any[], title: string) => void;
}) {
  if (!locations?.length) {
    return <Typography sx={{ fontSize: '0.8rem', color: '#9ca3af' }}>N/A</Typography>;
  }
  const isPickup  = type === 'pickup';
  const dotColor  = isPickup ? '#16a34a' : '#0061ff';
  const dotRing   = isPickup ? '#bbf7d0' : '#b4cbf0';
  const title     = isPickup ? 'Pickup Locations' : 'Delivery Locations';
  const maxShow   = 1;
 const shown = isPickup
  ? locations.slice(0, maxShow)
  : locations.slice(-maxShow);
  const extra     = locations.length - maxShow;
  console.log("shown", shown)
  const handleOpenModal = () => openModal(type, locations as any[], title);

  return (
    <Box sx={{lineHeight:'17px'}}>
      {shown.map((loc, i) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 0.8,}}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
            <Box sx={{
              width: 8, height: 8, mt: '0px', borderRadius: '50%',
              bgcolor: dotColor, boxShadow: `0 0 0 2px ${dotRing}`,
            }} />
            {i < shown.length - 1 && (
              <Box sx={{ width: 1.5, minHeight: 12, my: 0 }} />
            )}
          </Box>
          <Box sx={{width:'100%'}}>
            <Typography className='tellipsis' sx={{ fontSize:{xs:'13px', md:'14px'}, fontWeight: 600, color: '#101721', mb:0, lineHeight:'18px'}}>
              {loc.city}, {loc.state}
            </Typography>
            {/* {loc.address && (
              <Typography sx={{ fontSize: '0.69rem', color: '#6b7280', lineHeight: 1.3 }}>
                {loc.address}
              </Typography>
            )} */}
          </Box>
        </Box>
      ))}
        <Button
          onClick={handleOpenModal}
          sx={{
            ml: 1.5, p: 0, minWidth: 'auto', fontSize: '0.75rem', height:'auto',
            textTransform: 'none', color: dotColor, fontWeight: 600, lineHeight:'1',
            '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
          }}
        >
        {extra>0 ?`+${extra} more stop${extra > 1 ? 's' : ''}`:`Read more`}
        </Button>

    </Box>
  );
}